<div class="button-wrapper">
    <button app-round-button mat-dialog-close><fa-icon icon="chevron-right"></fa-icon></button>
    <button app-round-button *ngIf="!Editing" (click)="Editing = true"><fa-icon icon="pencil-alt"></fa-icon></button>
    <button app-round-button *ngIf="Editing" (click)="materialData.SaveForm()"><fa-icon icon="save"></fa-icon></button>
    <button app-round-button *ngIf="Editing" (click)="materialData.ResetForm(); Editing = false"><fa-icon icon="undo"></fa-icon></button>
</div>
<div class="scrollbar" >
    <app-material-main-data #materialData [FolderId]="FolderId$ | async" [(Editing)]="Editing" [MaterialId]="Dialogdata.MaterialId"></app-material-main-data>
    <app-file-explorer [FileUploadButton]="true" *ngIf="FolderId$ | async as folderId" [SelectedFolderId]="folderId"></app-file-explorer>
</div>
